<template>
  <form :id="id" @submit.prevent="submitForm" ref="form">
    <slot
      v-bind="{
        errorBag,
        isSubmitting,
        setErrors,
        validate,
        resetForm,
        submit: submitForm
      }"
    >
    </slot>
  </form>
</template>

<script setup lang="ts">
  import { useForm, useIsFormValid } from 'vee-validate'
  import type { PropType } from '@vue/runtime-core'

  const props = defineProps({
    ...Id.props,
    onSubmit: {
      type: Function,
      default: () => () => {}
    },
    onRejectedSubmit: {
      type: Function,
      default: () => () => {}
    },
    validationSchema: {
      default: () => ({})
    }
  })

  const { handleSubmit, errorBag, isSubmitting, setErrors, validate, resetForm } = useForm({
    validationSchema: props.validationSchema
  })

  const isValid = useIsFormValid()

  //@ts-ignore
  const submitForm = handleSubmit(props.onSubmit, props.onRejectedSubmit)

  defineExpose({
    setErrors,
    validate,
    resetForm,
    isSubmitting,
    isValid,
    submit: submitForm
  })
</script>

<style scoped></style>
